import { ROUTES } from '@/app/router/routes';
import { PlusIcon, UploadIcon } from '@/components/icons';
import { NAV_ITEMS } from './navigation';

export const QUICK_NAVIGATION = [
  {
    label: 'Ajouter un candidat',
    detail: 'À partir d’un CV',
    to: ROUTES.candidateImport + '?type=cv',
    icon: UploadIcon,
    group: 'Actions rapides',
    keywords: 'importer ajouter cv profil candidat',
  },
  {
    label: 'Ajouter une société',
    detail: 'Nouvelle entreprise',
    to: ROUTES.companyCreate,
    icon: PlusIcon,
    group: 'Actions rapides',
    keywords: 'creer entreprise societe',
  },
  {
    label: 'Ajouter un contact',
    detail: 'Nouvelle fiche contact',
    to: ROUTES.contactCreate,
    icon: PlusIcon,
    group: 'Actions rapides',
    keywords: 'creer contact',
  },
  {
    label: 'Créer un besoin',
    detail: 'Nouvelle mission à pourvoir',
    to: ROUTES.requirementCreate,
    icon: PlusIcon,
    group: 'Actions rapides',
    keywords: 'ajouter besoin mission',
  },
  {
    label: 'Créer une action',
    detail: 'Appel, rendez-vous, suivi…',
    to: ROUTES.actionCreate,
    icon: PlusIcon,
    group: 'Actions rapides',
    keywords: 'ajouter action appel entretien relance rendez vous',
  },
  {
    label: 'Créer une facture',
    detail: 'Administration des ventes',
    to: ROUTES.advInvoiceCreate,
    icon: PlusIcon,
    group: 'Actions rapides',
    keywords: 'ajouter facture adv',
  },
  {
    label: 'Créer un bon de commande',
    detail: 'Administration des ventes',
    to: ROUTES.advOrderCreate,
    icon: PlusIcon,
    group: 'Actions rapides',
    keywords: 'ajouter commande adv',
  },
  {
    label: 'Créer un contrat',
    detail: 'Administration des ventes',
    to: ROUTES.advContractCreate,
    icon: PlusIcon,
    group: 'Actions rapides',
    keywords: 'ajouter contrat adv',
  },
  {
    label: 'Créer une proposition',
    detail: 'Proposition commerciale',
    to: ROUTES.advPropositionCreate,
    icon: PlusIcon,
    group: 'Actions rapides',
    keywords: 'ajouter devis proposition adv',
  },
  {
    label: 'Créer un PVA',
    detail: 'Procès-verbal d’activité',
    to: ROUTES.advPvaCreate,
    icon: PlusIcon,
    group: 'Actions rapides',
    keywords: 'ajouter pva activite adv',
  },
  ...NAV_ITEMS.flatMap((item) =>
    item.to
      ? [
          {
            label: item.to === ROUTES.candidates ? 'Voir les candidats' : item.label,
            detail: 'Ouvrir la page',
            to: item.to,
            icon: item.icon,
            group: 'Pages',
            keywords: `voir liste consulter ${item.label} ${item.to === ROUTES.companies ? 'entreprises sociétés contacts' : ''}`,
          },
        ]
      : [],
  ),
];

const normalize = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const searchQuickNavigation = (query: string) => {
  const words = normalize(query).trim().split(/\s+/).filter(Boolean);
  return QUICK_NAVIGATION.filter((item) => {
    const text = normalize(`${item.label} ${item.detail} ${item.keywords}`);
    return words.every((word) => text.includes(word));
  });
};
